import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import DesktopMenu from "./deskTopMenu";
import MobileMenu from "./mobileMenu";
import { MenuContainer } from "./styles";

const MenuList = [
  [
    "Buy Now",
    "https://app.uniswap.org/#/swap?outputCurrency=0xd111C8516BAFED13fB2F50c2fdf4031C181Cdc76&chain=mainnet",
  ],
  [
    "Chart View",
    "https://www.dextools.io/app/en/ether/pair-explorer/0xd464b607f64093ce8fb6b68d34e9992c01eef059",
  ],
  ["About Us", "/#aboutus"],
  ["Ecosystem", "/#ecosystem"],
  ["Roadmap", "/#roadmap"],
  ["Tokenomics", "/#tokenomics"],
  ["Socials", "/#socials"],
  ["FAQ", "/#faq"],
  ["Join Telegram", "https://t.me/proofofape"],
];

const checkSticky = "";
const Menu = () => {
  // const [useCheckSticky, setCheckSticky] = useState("no-sticky");
  // useEffect(() => {
  //   window.addEventListener("scroll", isSticky);
  //   return () => {
  //     window.removeEventListener("scroll", isSticky);
  //   };
  // });
  // const isSticky = (e) => {
  //   const scrollTop = window.scrollY;
  //   scrollTop >= 20 ? setCheckSticky("sticky") : setCheckSticky("No-sticky");
  // };
  return (
    <MenuContainer
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      // data-aos-delay="500"
      // data-aos-offset="0"
      data-aos-duration="1000"
    >
      <DesktopMenu menuList={MenuList} />
      <MobileMenu menuList={MenuList} />
    </MenuContainer>
  );
};

export default Menu;
